import { Object3D } from 'three';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import type { RefObject } from 'react';

import 'app/modules/wallforming/custom-styles/customEmptyStateStyle.css';

interface HeatmapProps {
    heatmapRef: RefObject<HTMLCanvasElement | null>;
}

export const Heatmap = ({ heatmapRef }: HeatmapProps) => {
    Object3D.DEFAULT_UP.set(0, 0, 1);

    const { showHeatmapOverlay, showHeatmapLabels, showHeatmapHover } = usePlacementStore(
        useShallow((s) => ({
            showHeatmapOverlay: s.showHeatmapOverlay,
            showHeatmapLabels: s.showHeatmapLabels,
            showHeatmapHover: s.showHeatmapHover
        }))
    );

    return (
        <>
            {(showHeatmapOverlay || showHeatmapLabels || showHeatmapHover) && (
                <div className="absolute inset-0 pointer-events-none" style={{ zIndex: 10 }}>
                    <canvas ref={heatmapRef} className="absolute inset-0 w-full h-full" />
                </div>
            )}
        </>
    );
};
